import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a189744"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert alert-primary" }

import { computed, ref } from 'vue'
import { ShieldIcon } from '@zhuowenli/vue-feather-icons'
import Modal from '@webapp/util/Modal.vue'
import { useSyncSessionStore } from './SyncSessionStore'
import LivingPeopleEditor from './LivingPeopleEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LivingPeopleModal',
  props: {
    sessionId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  open,
})

const syncSessionStore = useSyncSessionStore()

const modalRef = ref<InstanceType<typeof Modal>>()

const showSelectDefaultRef = computed(() => !syncSessionStore.getSession(props.sessionId)?.lastSyncId)

function open() {
  modalRef.value?.open()
}

function selectDefault() {
  syncSessionStore.selectDefaultLivingWindowPersons(props.sessionId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    info: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Living people to include")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Done")
    ]),
    secondaryContent: _withCtx(() => [
      (showSelectDefaultRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary select-default",
            onClick: selectDefault
          }, " Select default "))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ShieldIcon), {
          size: "1.3x",
          class: "privacy"
        }),
        _createTextVNode(" You should only include people you know personally. ")
      ]),
      _createVNode(LivingPeopleEditor, { "session-id": _ctx.sessionId }, null, 8, ["session-id"])
    ]),
    _: 1
  }, 512))
}
}

})